import React, { useEffect, useState } from "react";
import { Button, message } from "antd";
import { useB2BContext } from "../../context/ContextB2B";
import moment from "moment";
import { authSVC } from "../../services";
import { useNavigate } from "react-router-dom";
import RequestedPackageHDFC from "./RequestedPackageHDFC";
import AddonsModules from "./AddonsModules";
import "./Plan.scss";
import { AppModal } from "../../components/common";

function Plan() {
  const { paymentDetails, getUserByID, setPaymentDetails, allPackageList } = useB2BContext();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenReference, setIsModalOpenReference] = useState(false);
  const [isModalOpenReferenceAnotherPlan, setIsModalOpenReferenceAnotherPlan] = useState(false);
  const [isModalOpenPayment, setIsModalOpenPayment] = useState<any>();
  const [isModalOpenaddons, setIsModalOpenaddons] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [viewAllModules, setViewAllModules] = useState<any>();
  const [packageData, setPackageData] = useState<any>();
  const [step1, setStep1] = useState<any>(true);
  const [packageName, setPackageName] = useState<any>();
  const [packageId, setPackageId] = useState<any>();
  const [additional, setAdditional] = useState<any>(false);
  const navigate = useNavigate();
  const [copied, setCopied] = useState(false);
  const [referenceId, setReferenceId] = useState<any>();
  const [requestedPackageData, setRequestedPackageData] = useState<any>();
  const [upgradeStatus, setUpgradeStatus] = useState();

  useEffect(() => {
    if (requestedPackageData) setIsModalOpenPayment(true);
  }, [requestedPackageData]);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(referenceId);
      setCopied(true);
      message.success("Copied!");
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  const handleOkReference = () => setIsModalOpenReference(true);
  const handleCancelReference = () => setIsModalOpenReference(false);
  const handleOkReferenceAnotherPlan = () => setIsModalOpenReferenceAnotherPlan(true);
  const handleCancelReferenceAnotherPlan = () => setIsModalOpenReferenceAnotherPlan(false);
  const handleOk = () => setIsModalOpen(false);
  const handleCancel = () => { setIsModalOpen(false); setStep1(true); };
  const handleOkPayment = () => setIsModalOpenPayment(true);
  const handleCancelPayment = () => setIsModalOpenPayment(false);
  const handleOkAddons = () => setIsModalOpenaddons(false);
  const handleCancelAddons = () => setIsModalOpenaddons(false);

  const openPaymentUpdate = () => setIsModalOpen(true);
  const RequestAnotherPlan = () => { setIsModalOpen(true); setAdditional(true); setStep1(false); };

  const ClickRequestAnotherPlan = () => {
    authSVC.MembershipUpdates({ user: getUserByID._id, package: selectedOption, request_type: "additional" })
      .then((res: any) => {
        setReferenceId(res.data.data.reference_id);
        message.success("Request successfully sent.");
        setIsModalOpen(false);
        setIsModalOpenReference(true);
        navigate("/plan");
      })
      .catch((err: any) => {
        setReferenceId(err?.response?.data?.availableUpgradeRequest?.reference_id);
        setIsModalOpen(false);
        setIsModalOpenReferenceAnotherPlan(true);
        message.error(err.response.data.error);
      });
  };

  const ClickUpdate = () => {
    if (selectedOption) {
      authSVC.MembershipUpdates({ user: getUserByID._id, package: selectedOption })
        .then((res: any) => {
          setReferenceId(res.data.data.reference_id);
          message.success("Request successfully sent.");
          setIsModalOpenReference(true);
          setIsModalOpen(false);
          navigate("/plan");
        })
        .catch((err: any) => {
          setReferenceId(err?.response?.data?.availableUpgradeRequest?.reference_id);
          setIsModalOpen(false);
          setIsModalOpenReferenceAnotherPlan(true);
          message.error(err.response.data.error);
        });
    }
  };

  useEffect(() => { AllModule(); }, [getUserByID]);

  const AllModule = async () => {
    authSVC.getAllModule().catch((err: any) => message.error(err.message));
  };

  const ViewAddOns = (packageId: any) => {
    setIsModalOpenaddons(true);
    if (getUserByID) {
      authSVC.GetModules(getUserByID?.company_id?._id, packageId)
        .then((res: any) => setViewAllModules(res.data))
        .catch((err: any) => message.error(err.message));
    }
  };

  useEffect(() => {
    if (getUserByID) {
      authSVC.getMappedPackageList(getUserByID?.company_id?._id)
        .then((res: any) => setPackageData(res.data.package))
        .catch((err: any) => message.error(err.message));

      authSVC.UpgradeStatus(getUserByID?.company_id?._id)
        .then((res: any) => setUpgradeStatus(res.data.status))
        .catch((err: any) => message.error(err.message));
    }
  }, [getUserByID]);

  // Tier badge colour
  const tierColor: Record<string, string> = {
    GOLD: "#C8963E",
    PLATINUM: "#7B8FA8",
    DIAMOND: "#4FA1A5",
  };

  return (
    <div className="plan-page">

      {/* ── Pending payment banner ──────────────────────────────────────── */}
      {getUserByID?.company_id?.package?.some((i: any) => i.payment_done === false) && (
        <div className="plan-page__pending-bar">
          <span className="plan-page__pending-dot" />
          <span>You have pending payment(s)</span>
          {getUserByID?.company_id?.package
            ?.filter((i: any) => i.payment_done === false)
            .map((item: any, idx: number) => (
              <button
                key={idx}
                className="plan-page__pending-btn"
                onClick={() => setRequestedPackageData(item)}
              >
                View &amp; Pay Now
              </button>
            ))}
        </div>
      )}

      {/* ── Page header ─────────────────────────────────────────────────── */}
      <div className="plan-page__header">
        <div>
          <h1 className="plan-page__title">Subscription Plan</h1>
          <p className="plan-page__subtitle">Manage and upgrade your active wellness plans.</p>
        </div>
      </div>

      {/* ── Content ─────────────────────────────────────────────────────── */}
      <div className="plan-page__content">

        {packageData === undefined ? null
          : packageData ? (
            <>
              {/* Plan cards */}
              <div className="plan-cards">
                {packageData?.map((data: any, idx: number) => {
                  const tier = data?.package?.toUpperCase();
                  const accent = tierColor[tier] || "#3170B5";
                  const isActive = data.payment_done;

                  return (
                    <div
                      key={idx}
                      className={`plan-card ${isActive ? "plan-card--active" : "plan-card--inactive"}`}
                      style={{ "--card-accent": accent } as React.CSSProperties}
                    >
                      {/* Card top stripe */}
                      <div className="plan-card__stripe" />

                      <div className="plan-card__body">
                        {/* Status pill */}
                        <span className={`plan-card__status ${isActive ? "plan-card__status--active" : "plan-card__status--inactive"}`}>
                          {isActive ? "● Active" : "○ Not Activated"}
                        </span>

                        {/* Tier name */}
                        <h2 className="plan-card__tier">{data?.package}</h2>

                        {/* Price */}
                        <div className="plan-card__price">
                          <span className="plan-card__currency">₹</span>
                          <span className="plan-card__amount">{data?.price}</span>
                        </div>

                        {/* Expiry */}
                        <p className="plan-card__expiry">
                          Expires{" "}
                          <strong>{moment(data?.next_renewal_date).format("DD MMM YYYY")}</strong>
                        </p>
                      </div>

                      <div className="plan-card__footer">
                        <button
                          className="plan-card__addons-btn"
                          onClick={() => {
                            ViewAddOns(data._id);
                            setPackageName(data.package);
                            setPackageId(data._id);
                          }}
                        >
                          View add-ons
                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <path d="M1 7h12M8 2l5 5-5 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </button>

                        {packageData.length !== 2 &&
                          data?.package !== "PLATINUM" &&
                          upgradeStatus !== true && (
                            <button
                              className="plan-card__upgrade-btn"
                              onClick={openPaymentUpdate}
                            >
                              Upgrade Plan
                            </button>
                          )}
                      </div>
                    </div>
                  );
                })}

                {/* Request another plan card */}
                {packageData.length !== 2 && (
                  <button className="plan-card plan-card--ghost" onClick={RequestAnotherPlan}>
                    <div className="plan-card__ghost-inner">
                      <span className="plan-card__ghost-icon">+</span>
                      <span className="plan-card__ghost-label">Request Another Plan</span>
                      <span className="plan-card__ghost-hint">Add a second subscription tier</span>
                    </div>
                  </button>
                )}
              </div>
            </>
          ) : (
            <div className="plan-page__empty">
              <span className="plan-page__empty-icon">📭</span>
              <p>Your subscription plan has not been activated yet.</p>
            </div>
          )}
      </div>

      {/* ── Upgrade / Request modal ──────────────────────────────────────── */}
      <AppModal
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        className="plan-modal"
      >
        {step1 ? (
          <div className="plan-modal__inner">
            <div className="plan-modal__icon-wrap">
              <img src="/Group14181.svg" alt="" className="plan-modal__icon" />
            </div>
            <h3 className="plan-modal__heading">Unlock More Wellness!</h3>
            <p className="plan-modal__desc">
              Upgrade your SOULSARA plan today and access premium features that take your team's well-being to the next level.
            </p>
            <button className="plan-modal__cta" onClick={() => { setStep1(false); setAdditional(false); }}>
              Upgrade Plan
            </button>
          </div>
        ) : (
          <div className="plan-modal__inner">
            <div className="plan-modal__icon-wrap">
              <img src="/Group14181.svg" alt="" className="plan-modal__icon" />
            </div>
            <h3 className="plan-modal__heading">
              {additional ? "Request Another Plan" : "Confirm Membership Upgrade"}
            </h3>

            <div className="plan-modal__plan-row">
              <div className="plan-modal__plan-box">
                <span className="plan-modal__plan-role">Current Plan</span>
                <strong>{packageData?.[0]?.package}</strong>
              </div>
              <div className="plan-modal__arrow">→</div>
              <div className="plan-modal__plan-box plan-modal__plan-box--select">
                <span className="plan-modal__plan-role">{additional ? "Request Plan" : "Upgrade To"}</span>
                <select
                  className="plan-modal__select"
                  onChange={(e) => setSelectedOption(e.target.value)}
                >
                  <option value="">Select Plan</option>
                  {allPackageList?.map((option: any) =>
                    packageData?.[0]?.package !== option.package ? (
                      <option key={option.code} value={option.code}>{option.package}</option>
                    ) : null
                  )}
                </select>
              </div>
            </div>

            <button
              className="plan-modal__cta"
              onClick={additional ? ClickRequestAnotherPlan : ClickUpdate}
              disabled={!selectedOption}
            >
              {additional ? "Request Another Plan" : "Continue"}
            </button>
          </div>
        )}
      </AppModal>

      {/* ── Reference ID modal (success) ────────────────────────────────── */}
      <AppModal
        open={isModalOpenReference}
        onOk={handleOkReference}
        onCancel={handleCancelReference}
        className="plan-modal"
      >
        <div className="plan-modal__inner">
          {/* <div className="plan-modal__success-icon">✅</div> */}
          <h3 className="plan-modal__heading">Request Submitted!</h3>
          <p className="plan-modal__desc">
            Thank you for your request. We'll be in touch shortly. Use the reference ID to follow up — you'll also receive an email confirmation.
          </p>
          <div className="plan-modal__ref-box">
            <span className="plan-modal__ref-label">Reference ID</span>
            <div className="plan-modal__ref-row">
              <code className="plan-modal__ref-id">{referenceId}</code>
              <button className="plan-modal__copy-btn" onClick={handleCopy}>
                {copied ? "✓ Copied" : "Copy"}
              </button>
            </div>
          </div>
        </div>
      </AppModal>

      {/* ── Reference ID modal (pending) ─────────────────────────────────── */}
      <AppModal
        open={isModalOpenReferenceAnotherPlan}
        onOk={handleOkReferenceAnotherPlan}
        onCancel={handleCancelReferenceAnotherPlan}
        className="plan-modal"
      >
        <div className="plan-modal__inner">
          <div className="plan-modal__icon-wrap">
            <img src="/Group17939.png" alt="" className="plan-modal__icon" />
          </div>
          <h3 className="plan-modal__heading">Request In Progress</h3>
          <p className="plan-modal__desc">
            Your previous request is still being processed. You can follow up using the reference ID below.
          </p>
          <div className="plan-modal__ref-box">
            <span className="plan-modal__ref-label">Reference ID</span>
            <div className="plan-modal__ref-row">
              <code className="plan-modal__ref-id">{referenceId}</code>
              <button className="plan-modal__copy-btn" onClick={handleCopy}>
                {copied ? "✓ Copied" : "Copy"}
              </button>
            </div>
          </div>
          <a href="https://www.soulsara.world/contact-us" target="_blank" rel="noreferrer" className="plan-modal__cta plan-modal__cta--outline">
            Contact Us
          </a>
        </div>
      </AppModal>

      {/* ── Add-ons modal ────────────────────────────────────────────────── */}
      <AppModal
        open={isModalOpenaddons}
        onOk={handleOkAddons}
        onCancel={handleCancelAddons}
        className="plan-modal"
      >
        <div className="plan-modal__inner">
          <div className="plan-modal__icon-wrap">
            <img src="img/plan_icon01.svg" alt="" className="plan-modal__icon" />
          </div>
          <span className="plan-modal__sub-text">Subscription Plan</span>
          <h2 className="plan-modal__heading">{packageName}</h2>
          <div className="plan-modal__addons-body">
            <AddonsModules selectedPackageId={packageId} />
          </div>
        </div>
      </AppModal>

      {/* ── Payment modal ────────────────────────────────────────────────── */}
      <AppModal
        title="Subscription Checkout"
        open={isModalOpenPayment}
        onOk={handleOkPayment}
        onCancel={handleCancelPayment}
        className="plan-modal"
      >
        <RequestedPackageHDFC requestedPackageData={requestedPackageData} />
      </AppModal>
    </div>
  );
}

export default Plan;